import { FC } from 'react';

type Props = {
  value?: string;
};
const SubscriptionCustomCell: FC<Props> = ({ value }) => {
  return <div>{value}</div>;
};

export { SubscriptionCustomCell };
